import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// WhatsApp helpers
export function buildWhatsAppUrl(phoneNumber, message) {
  try {
    const digits = String(phoneNumber || "").replace(/\D/g, "");
    // If 10-digit Indian mobile, prepend country code 91
    const normalized = digits.length === 10 ? `91${digits}` : digits;
    const encodedMsg = encodeURIComponent(message || "");
    return `https://wa.me/${normalized}?text=${encodedMsg}`;
  } catch (e) {
    return "https://wa.me/";
  }
}

export function openWhatsApp(phoneNumber, message) {
  const url = buildWhatsAppUrl(phoneNumber, message);
  if (typeof window !== 'undefined') {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
  return url;
}